import { Module } from 'vuex';
import { rootState } from '../state';
import storageObservable from '@/api/storageObservable';
import REQ_URL from '@/consts/req-url';
import { $fetch } from '@/api/fetch';
import { DeferredStorage } from '@/types/deferred-storage';
import { sProductsToProducts } from '@/api/product';

interface deferredElParam {
    key: string
    val: string
}
type deferredElParams = deferredElParam[]

let plannedUnload: number | null = null
//отклонённые заказы, товары которых уже возвращены в корзину, а запись в хранилище sw ещё не удалена
const RETURNED_ORDERS_KEY = 'returnedDefReq'
function readReturnedOrders(): string[] {
    try {
        const keys = JSON.parse(localStorage.getItem(RETURNED_ORDERS_KEY) || '[]')
        return Array.isArray(keys) ? keys : []
    } catch (error) {
        return []
    }
}
function writeReturnedOrders(keys: string[]) {
    try {
        localStorage.setItem(RETURNED_ORDERS_KEY, JSON.stringify(keys))
    } catch (error) {
        console.error(error)
    }
}

const state = {
    offlineMode: false,
    /**
     * автозагрузка в idb
     */
    autoDownload: false,
    /**
     * автоматическая выкачка deferred storage
     */
    autoUploadDS: localStorage && localStorage.getItem('autoUploadDS') ? JSON.parse(localStorage.getItem('autoUploadDS') as string) : true,
    networkState: 'online' as 'online' | 'offline',
    /**
     * Если надо обновить страницу для нового service worker'а
     */
    needUpdate: false,
    swSupport: 'serviceWorker' in navigator,
    deferredStorage: [] as DeferredStorage
}

export const networkStateStore: Module<typeof state, typeof rootState> = {
    state,
    mutations: {
        setNetworkState(state, status: 'online' | 'offline') {
            state.networkState = status
        },
        setAutoDownload(state, status: boolean) {
            state.autoDownload = status
        },
        setUpdateState(state, status: boolean) {
            state.needUpdate = status
        },
        setSwSupport(state, status: boolean) {
            state.swSupport = status
        },
        setOfflineMode(state, status: boolean) {
            state.offlineMode = status
        },
        setDeferredStorage(state, storage) {
            state.deferredStorage = storage
        },
        deleteDeferredStorageEl(state, primaryKey) {
            let ind = state.deferredStorage.findIndex((el) => {
                return el.key === primaryKey
            })
            if (ind !== -1) state.deferredStorage.splice(ind, 1)
        }

    },
    actions: {
        setNetworkState(c, status: 'online' | 'offline') {
            c.commit('setNetworkState', status);
            if (status === 'online') c.dispatch('unloadDeferredStorage')
        },
        setAutoDownload(c, status: boolean) {
            let autoDownloadStateNew: { status: boolean, user: string }[] = [{
                status,
                user: c.rootGetters.profile.email
            }]
            if (localStorage && localStorage.getItem('autoDownload')) {
                let autoDownloadStates =  (JSON.parse(localStorage.getItem('autoDownload') as string) as { status: boolean, user: string }[])
                let autoDownloadStateInd = autoDownloadStates.findIndex((state) => state.user === c.rootGetters.profile.email)
                if (autoDownloadStateInd !== -1) {
                    autoDownloadStates[autoDownloadStateInd].status = status
                    autoDownloadStateNew = autoDownloadStates
                }
            }
            storageObservable.emit('autoDownload', autoDownloadStateNew, false)
            c.commit('setAutoDownload', status)
        },
        setOfflineMode(c, status) {
            let offlineModeStateNew: { status: boolean, user: string }[] = [{
                status,
                user: c.rootGetters.profile.email
            }]
            if (localStorage && localStorage.getItem('offlineMode')) {
                let offlineModeStates =  (JSON.parse(localStorage.getItem('offlineMode') as string) as { status: boolean, user: string }[])
                let offlineModeStateInd = offlineModeStates.findIndex((state) => state.user === c.rootGetters.profile.email)
                if (offlineModeStateInd !== -1) {
                    offlineModeStates[offlineModeStateInd].status = status
                    offlineModeStateNew = offlineModeStates
                }
            }
            storageObservable.emit('offlineMode', offlineModeStateNew, false)
            c.commit('setOfflineMode', status)
        },
        async setDeferredStorage(c) {
            if (c.state.swSupport) {
                try {
                    let res = await fetch(REQ_URL.GET_DEFREQ)
                    let data = await res.json()
                    c.commit('setDeferredStorage', data)
                } catch (error) {

                }
            }
        },
        async uploadDeferredStorage(c) {
            if (localStorage.getItem('lockUploadDS') && JSON.parse(localStorage.getItem('lockUploadDS') as string)) return;
            storageObservable.emit('lockUploadDS', true)
            for (let i = 0; i < c.state.deferredStorage.length; i++) {
                c.state.deferredStorage[i].body
                try {
                    await $fetch<any>(REQ_URL[c.state.deferredStorage[i].reqType], {
                        method: c.state.deferredStorage[i].method,
                        body: JSON.stringify(c.state.deferredStorage[i].body)
                    })
                    c.commit('deleteDeferredStorageEl', c.state.deferredStorage[i].key)
                } catch (error) {

                }
            }
            storageObservable.emit('lockUploadDS', false)
        },
        async uploadDeferredStorageEl(c, primaryKey) {
            if (localStorage.getItem('lockUploadDS') && JSON.parse(localStorage.getItem('lockUploadDS') as string)) return;
            storageObservable.emit('lockUploadDS', true)
            let ind = c.state.deferredStorage.findIndex((el) => {
                return el.key === primaryKey
            })
            if (ind === -1) return false;
            try {
                await $fetch(REQ_URL[c.state.deferredStorage[ind].reqType], {
                    method: c.state.deferredStorage[ind].method,
                    body: JSON.stringify(c.state.deferredStorage[ind].body)
                })
                c.commit('deleteDeferredStorageEl', c.state.deferredStorage[ind].key)
            } catch (error) {

            }
            storageObservable.emit('lockUploadDS', false)
        },
        unloadDeferredStorage(c) {
            //подождем определенное время, чтобы убедиться в стабильности соединения
            if (plannedUnload != null) {
                clearTimeout(plannedUnload);
            }
            plannedUnload = setTimeout(async () => {
                try {
                    let res = await fetch(REQ_URL.UNLOAD_DEFREQ);
                } catch (error) {

                } finally {
                    plannedUnload = null
                }
                c.dispatch('returnRejectedOrders')
            }, 5000)

        },
        //отложенный заказ, который сервер отклонил при отправке (см. sw.js): корзина была очищена ещё при оформлении,
        //поэтому товары возвращаются в неё, а клиент узнаёт об отказе
        async returnRejectedOrders(c) {
            if (!c.state.swSupport) return
            try {
                let list = await (await fetch(REQ_URL.GET_DEFREQ)).json()
                if (!Array.isArray(list)) return
                const rejected = list.filter((defReq) => defReq.rejected && defReq.reqType === 'PLACE_AN_ORDER')
                //от этой строки и до возврата товаров ожиданий нет: корзину за это время не подменить (менеджер
                //сменил клиента), а отметка в localStorage не даст вернуть товары второй раз - ни другой вкладке,
                //ни после перезагрузки, если запись в хранилище sw удалить не удастся
                const returned = readReturnedOrders().filter((key) => rejected.some((defReq) => defReq.key === key))
                const drop = returned.slice()
                const reasons: string[] = []
                for (const defReq of rejected) {
                    if (returned.indexOf(defReq.key) !== -1) continue
                    //заказ клиента, корзина которого сейчас не открыта (менеджер): вернётся, когда её откроют
                    if (defReq.body.basket.token !== c.rootGetters.basketToken) continue
                    returned.push(defReq.key)
                    drop.push(defReq.key)
                    sProductsToProducts(defReq.body.basket.items).forEach((product) => c.dispatch('addProductToBasket', { product, quiet: true }))
                    if (reasons.indexOf(defReq.rejected) === -1) reasons.push(defReq.rejected)
                }
                writeReturnedOrders(returned)
                //окно одно на все заказы: следующее сообщение заменило бы предыдущее
                if (reasons.length) c.commit('modal:open', {
                    type: 'warning',
                    msg: `Отложенный заказ не принят (${reasons.join('; ')}). Товары возвращены в корзину.`
                })
                for (const key of drop) await fetch(REQ_URL.DROP_DEFREQ, { method: 'POST', body: JSON.stringify({ key }) })
            } catch (error) {
                console.error(error)
            }
        }
    },
    getters: {
        networkState(state) {
            return state.networkState
        },
        needUpdate(state) {
            return state.needUpdate
        },
        offlineMode(state) {
            return state.offlineMode
        },
        deferredEl: state => (primaryKey: string, params?: deferredElParams) => {
            state.deferredStorage.find((el) => {
                return el.key === primaryKey && (params && params.length ? params.every((param) => {
                    return (el as any)[param.key] && (el as any)[param.key] === param.val
                }) : true)
            })
        },
    }
}